import {useState, useEffect} from 'react';

/**
 * @hook useAuthentication
 * @description
 * Hook personalizado que determina si un usuario está autenticado
 * en base a la existencia de un token guardado en `localStorage` bajo la clave `user`.
 *
 * Este hook es útil para proteger rutas o condicionar la lógica basada en el estado de autenticación.
 *
 * @returns {boolean|null} Retorna `true` si el usuario está autenticado, `false` si no lo está,
 * o `null` mientras se evalúa el estado inicial.
 */
function useAuthentication() {
	const [isAuthenticated, setIsAuthenticated] = useState(null);

	useEffect(() => { /**
		 * Verifica si existe un token de autenticación válido en el localStorage.
		 */
		const checkAuthentication = () => {
			const userFromLocalStorage = localStorage.getItem('user');

			if (userFromLocalStorage) {
				const parsedUser = JSON.parse(userFromLocalStorage);
				setIsAuthenticated(!! parsedUser.token); // Devuelve true si token existe
			} else {
				setIsAuthenticated(false);
			}
		};

		checkAuthentication();

		// No se necesita cleanup
		return() => {};
	}, []);

	return isAuthenticated;
}

export default useAuthentication;
